import {useConfig} from '@aboutyou/config';
import {GetRecommendationsPageResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/product_recommendations_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import {ScrollSimilarItemsView} from '../../SimilarItemsScrollIntoView/ScrollSimilarItemsView';

import {useMiniAdpDialogOpenedState} from '../../../../features/MiniADPDialog/useMiniAdpDialogOpenedState';
import {InteractiveProductTile} from '../../../../features/ProductTile/InteractiveProductTile';
import {RecommendationsLane} from '../../../../features/Recommendations/RecommendationsLane';

export const SimilarProductsRecoView = (
  props: GetRecommendationsPageResponse,
) => {
  const {recommendations} = props;
  const {device} = useConfig();
  const {open: openProductMiniADPDialog} = useMiniAdpDialogOpenedState();
  const {t} = useTranslation();

  if (recommendations.length === 0) {
    return null;
  }

  return (
    <>
      <ScrollSimilarItemsView />
      <RecommendationsLane
        uniqueKey="similarProductsReco"
        data-testid="similarProductsReco"
        type="list"
        headline={t('Similar alternatives')}
        topline=""
        streamPosition={0}
        products={recommendations}
        ProductTileComponent={InteractiveProductTile}
        productTileConfig={{
          gridColumns: device === 'desktop' ? 4 : 2,
        }}
        promotionTracker={{
          promotionId: 'similar_products_reco_adp_soldout',
          promotionName: 'similar_products_reco_adp_soldout',
          creativeName: 'similar_products_reco_adp_soldout',
          creativeSlot: '0',
          locationId: 'similar_products_reco_adp_soldout',
        }}
        onAddToBasketCtaClick={({productId, couponPromotionId}) => {
          openProductMiniADPDialog({productId, couponPromotionId});
        }}
        trackComponentConfig={{
          location_id: 'adp_soldout_similar_products',
          page_type_id: 'article_detail',
        }}
        featureTrackingLabel="similarItems"
        featureGenericClickLabel="adpReco"
        hideSideButtons
        enableGridLayout
        centered
        moveSideNavTop
      />
    </>
  );
};
